import React from "react";
import ReactDOM from "react-dom";
import "./App/index.css";
import registerServiceWorker from "./registerServiceWorker";
import Root from "./App/Root";
import { LicenseManager } from "ag-grid-enterprise";

LicenseManager.setLicenseKey(
    "Avenir_Health__MultiApp_1Devs8_November_2019__MTU3MzE3MTIwMDAwMA==5fe24a203ae4d849fe9768ee0a3219f5"
);

ReactDOM.render(<Root />, document.getElementById("root"));
registerServiceWorker();
